import React from 'react';
import { useSelector } from 'react-redux';

import useEffectOnce from 'hooks/useEffectOnce';
import { InfluencerContent } from 'types/influencer';
import MelodyCarousel from 'components/common/MelodyCarousel';
import InlineBrandInfluencerShoppablePostCard from 'components/influencer/shoppablePosts/InlineBrandInfluencerShoppablePostCard';
import { getAmethystPageType } from 'helpers/analytics';
import { BrandShopTheLookPlacementType } from 'constants/amethystEnums';
import { track } from 'apis/amethyst';
import { evBrandShopTheLookImpression } from 'events/influencerShoppablePost';
import { transformContentForAmethystEvent } from 'helpers/ShoppablePostUtils';

import css from 'styles/components/influencer/shoppablePosts/brandInfluencerShoppablePostsCarousel.scss';

interface BrandInfluencerShoppablePostsCarouselProps {
  contents: InfluencerContent[];
}

export const BrandInfluencerShoppablePostsCarousel = ({ contents }: BrandInfluencerShoppablePostsCarouselProps) => {
  const pageType = useSelector(state => state.pageView.pageType);
  const sourcePage = getAmethystPageType(pageType);

  useEffectOnce(() => {
    const contentData = contents.map((content, index) => transformContentForAmethystEvent(content, index + 1));
    track(() => [
      evBrandShopTheLookImpression,
      {
        placementType: BrandShopTheLookPlacementType.CAROUSEL,
        contents: contentData,
        sourcePage
      }
    ]);
  });

  return (
    <div className={css.carouselWrapper}>
      <h2 className={css.heading}>Shop The Look For Outfits</h2>
      <MelodyCarousel showDots={false}>
        {contents.map((content, index) => {
          const { contentId = '' } = content;
          return (
            <InlineBrandInfluencerShoppablePostCard
              key={`shopTheLook-${contentId}`}
              content={content}
              className={css.cardOverride}
              cardIndex={index}
              isRenderedOnCarousel={true}
              sourcePage={sourcePage}
            />
          );
        })}
      </MelodyCarousel>
    </div>
  );
};

export default BrandInfluencerShoppablePostsCarousel;
